import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Loader from './nav/Loader';

import { connect } from "react-redux";
import { getTopScoresData } from "../actions/action_topscores";

class TopScores extends Component {
  constructor(props) {
      let columns = [
        {Header: 'Floor', accessor: 'floor'},
        {Header: 'Phorse', accessor: 'phorse'},
        {Header: 'Rings', accessor: 'rings'},
        {Header: 'Vault', accessor: 'vault'},
        {Header: 'Pbars', accessor: 'pbars'},
        {Header: 'Highbar', accessor: 'highbar'},
      ];
      let fxcols = [
        {
          Header: 'FLOOR High Scores',
          columns: [
            {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Score', accessor: 'max'},
          ]
        }
      ];
      let phcols = [
        {
          Header: 'PHORSE High Scores',
          columns: [
            {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Score', accessor: 'max'},
          ]
        }
      ];
      let srcols = [
        {
          Header: 'RINGS High Scores',
          columns: [
            {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Score', accessor: 'max'},
          ]
        }
      ];
      let vtcols = [
        {
          Header: 'VAULT High Scores',
          columns: [
            {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Score', accessor: 'max'},
          ]
        }
      ];
      let pbcols = [
        {
          Header: 'PBARS High Scores',
          columns: [
            {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Score', accessor: 'max'},
          ]
        }
      ];
      let hbcols = [
        {
          Header: 'HIGHBAR High Scores',
          columns: [
            {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.state.yearFilter+'/'+this.state.teamFilter+'/'+props.original.gymnast_id}>{props.value}</a>},
            {Header: 'Score', accessor: 'max'},
          ]
        }
      ];
      super(props);
      this.state = {
        cols: columns,
        fxcols: fxcols,
        phcols: phcols,
        srcols: srcols,
        vtcols: vtcols,
        pbcols: pbcols,
        hbcols: hbcols
      };
      this.defaultSortMethod = this.defaultSortMethod.bind(this);
      this.getYear = this.getYear.bind(this);
      this.getTable = this.getTable.bind(this);
  }
  componentDidMount() {
    this.props.getTopScoresData({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
    });
  }
  componentDidUpdate(prevProps) {
    if(prevProps.yearFilter !== this.props.yearFilter || prevProps.teamFilter !== this.props.teamFilter) {
      this.props.getTopScoresData({
        "year": this.props.yearFilter,
        "team": this.props.teamFilter
      });
    }
  }
  getYear() {
    return this.props.yearFilter;
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b

    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  getTable() {
    if(!this.props.showLoader){
      if(this.props.teamFilter > 0 && this.props.numRows > 0) {
        if(this.props.data.total > 0){
          return <div><div><p>The highest team score possible if everyone got their high score in a single meet.</p></div>
          <ReactTable
            className="-striped -highlight"
            data={this.props.data.scores}
            columns={this.state.cols}
            defaultSortMethod={this.defaultSortMethod}
            showPagination={false}
            defaultPageSize={this.props.numRows}
            pageSize={this.props.numRows}
          />
          <h3>Total Team Score: {Number(this.props.data.total).toFixed(3)}</h3>
          <br />
          <div className="row">
            <div className="small-12 medium-6 columns">
              <ReactTable
                className="-striped -highlight"
                data={this.props.data.floor}
                columns={this.state.fxcols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.props.fxrows}
                pageSize={this.props.fxrows}
              />
            </div>
            <div className="small-12 medium-6 columns">
              <ReactTable
                className="-striped -highlight"
                data={this.props.data.phorse}
                columns={this.state.phcols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.props.phrows}
                pageSize={this.props.phrows}
              />
            </div>
          </div>
          <div className="row">
            <div className="small-12 medium-6 columns">
              <ReactTable
                className="-striped -highlight"
                data={this.props.data.rings}
                columns={this.state.srcols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.props.srrows}
                pageSize={this.props.srrows}
              />
            </div>
            <div className="small-12 medium-6 columns">
              <ReactTable
                className="-striped -highlight"
                data={this.props.data.vault}
                columns={this.state.vtcols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.props.vtrows}
                pageSize={this.props.vtrows}
              />
            </div>
            <div className="small-12 medium-6 columns">
              <ReactTable
                className="-striped -highlight"
                data={this.props.data.pbars}
                columns={this.state.pbcols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.props.pbrows}
                pageSize={this.props.pbrows}
              />
            </div>
            <div className="small-12 medium-6 columns">
              <ReactTable
                className="-striped -highlight"
                data={this.props.data.highbar}
                columns={this.state.hbcols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.props.hbrows}
                pageSize={this.props.hbrows}
              />
            </div>
            </div><br />
            <p className="note">*Shows the five highest scores on each event for the season and calculates a total score as if they had all been received during a single meet. Each athlete is only counted once per event.</p>
            </div>;
          } else {
            return <div>No Results For This Year</div>;
          }
      } else {
        return <div>Please Pick a Team</div>
      }
    } else {
      return <Loader />
    }
  }
  render() {
    return (
      <div>
          <div className="row">
              <div className="small-12 columns">
                {this.getTable()}
              </div>
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    data: state.topScores.data,
    numRows: state.topScores.numRows,
    fxrows: state.topScores.fxrows,
    phrows: state.topScores.phrows,
    srrows: state.topScores.srrows,
    vtrows: state.topScores.vtrows,
    pbrows: state.topScores.pbrows,
    hbrows: state.topScores.hbrows,

    showLoader: state.topScores.showLoader
  };
}

export default connect(mapStateToProps, { getTopScoresData })(TopScores);
